import { computed } from 'mobx';

/**
 * 모델
 * 담당자이력정보
 * @window w_tb_e601_new
 * @category 보수현장등록
 */
export class EnrollmentInchargeModel {
  /**
   * 회사코드
   *
   * **data type** varchar(8)
   */
  readonly custcd: string;

  /**
   * 사업장코드
   *
   * **data type** varchar(2)
   */
  readonly spjangcd: string;

  /**
   * 순서
   *
   * **data type** varchar(2)
   */
  seq: string;

  /**
   * 담당자코드
   *
   * **data type** varchar(20)
   */
  perid: string;

  /**
   * 담당자명
   *
   * **data type** varchar(100)
   */
  pernm: string;

  /**
   * 시작일자
   *
   * **data type** varchar(8)
   */
  stdate: string;

  /**
   * 종료일자
   *
   * **data type** varchar(8)
   */
  enddate: string;

  /**
   * 비고
   *
   * **data type** varchar(100)
   */
  remark: string;

  /**
   * 변경자명
   *
   * **data type** varchar(100)
   */
  inpernm: string;

  /**
   * 신규인지
   *
   * **data type** varchar(1)
   */
  readonly new: string;

  constructor(data: any = {}, isNew: boolean = false) {
    this.custcd = data.custcd || '';
    this.spjangcd = data.spjangcd || '';
    this.seq = data.seq || '';
    this.perid = data.perid || '';
    this.pernm = data.pernm || '';
    this.stdate = data.stdate || '';
    this.enddate = data.enddate || '';
    this.remark = data.remark || '';
    this.inpernm = data.inpernm || '';
    this.new = isNew ? '1' : '0';
  }

  @computed
  get isNew() {
    return this.new === '1';
  }
}
